import { logger as LOG } from '@garnish/logger';

export const logger = LOG.extend('LAUNCHDARKLY');

LOG.enable('LAUNCHDARKLY');
